var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var ExploreFundsMapper = function (MFCollection) {
    if (MFCollection && MFCollection) {
        return {
            exploreContent: exploreFundsContent(MFCollection),
            MFCollection: MFCollection.map(function (ele) {
                return {
                    SubCategory: ele.subcat_name,
                    Category: ele.cat,
                    CategoryID: parseInt(ele.cat_id),
                    ID: parseInt(ele.id),
                    Tag: ele.tag,
                };
            }),
        };
    }
    return {};
};
var exploreFundsContent = function (MFCollection) {
    var e_1, _a;
    var result = {};
    var finalRes = {};
    MFCollection.forEach(function (x) {
        if (Object.keys(result).length > 0 &&
            Object.keys(result).find(function (item) { return item !== x.cat; })) {
            result[x.cat] = MFCollection.filter(function (data) {
                return x.cat === data.cat;
            });
        }
        else {
            result[x.cat] = MFCollection.filter(function (data) {
                return x.cat === data.cat;
            });
        }
    });
    var _loop_1 = function (key, value) {
        finalRes[key] = {};
        if (value) {
            var explore_1 = value;
            explore_1.forEach(function (m) {
                if (Object.keys(finalRes[key]).length > 0 &&
                    Object.keys(finalRes[key]).find(function (item) { return item !== m.tag; })) {
                    finalRes[key][m.tag] = explore_1.filter(function (data) {
                        return m.tag === data.tag;
                    });
                }
                else {
                    finalRes[key][m.tag] = explore_1.filter(function (data) {
                        return m.tag === data.tag;
                    });
                }
            });
        }
    };
    try {
        for (var _b = __values(Object.entries(result)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            _loop_1(key, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return finalRes;
};
export default ExploreFundsMapper;
